<style scoped>
    .select-btn{
        margin-bottom: 5px;
    }
    .select-poptip{
        width: 100%;
    }
    .select-poptip /deep/ .ivu-poptip-rel{
        width: 100%;
    }
</style>
<template>
    <div>
        <Poptip class="select-poptip" width="400" :trigger="trigger" placement="bottom">
            <div>
                <!--<slot>-->
                    <!--<span>请在slot中定义你要显示的内容</span>-->
                <!--</slot>-->
                <slot></slot>
            </div>
            <div slot="content">
                <div class="line" v-if="!hideSearchBar">
                    <i-input v-model="params.search" @on-change="innerSearch" placeholder="搜索供应商">
                        <Button slot="append" @click="innerSearch" icon="ios-search" :loading="loading">搜索</Button>
                    </i-input>
                    <div class="hr"></div>
                </div>
                <div :class="{'color-error': company.is_abnormal}" class="select-btn ivu-btn ivu-btn-small ivu-btn-long"
                    @click="setPayeeCompany(company)"
                    v-for="company in results"
                    :key="company.id">
                    <div v-if="company.is_abnormal">
                        <span>已被列入黑名单: </span>
                        <span v-html="company.abnormal_reason"></span>
                    </div>
                    <div>
                        <span>{{company.name}}</span>
                        <span v-if="company.company_type === 0">- {{company.id_number || '未录入证件信息'}}</span>
                    </div>
                </div>
                <div class="text-center" v-show="loading">
                    <Spin></Spin>
                </div>
                <div class="color-grey text-center" v-if="!results.length">无搜索结果</div>
            </div>
        </Poptip>
    </div>
</template>
<script>
    export default {
        props: {
            trigger: {
                type: String,
                default: 'click'
            },
            type: {
                type: String,
                required: true
            },
            hideSearchBar: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                params: {
                    search: '',
                    type: ''
                },
                results: [],
                loading: false
            }
        },
        computed: {
            cur_customer(){
                return this.$store.state.cur_customer;
            },
        },
        created(){
            this.initType();
        },
        mounted(){
            //
        },
        methods: {
            initType(){
                this.params.type = this.type;
            },
            // 暴露给外部的接口
            search(search){
                this.params.search = search;
                this.innerSearch();
            },
            innerSearch(){
                if(this.loading) return;
                this.loading = true;
                Util.ajax.get(Util.api.query_payee_company_name, {
                    params: this.params
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    if(res.code === 1){
                        let data = res.data;
                        this.results = data.payee_companies;
                    }else{
                        this.$Modal.warning({title: '错误', content: res.msg});
                    }
                }).catch((e)=>{
                    this.$Modal.warning({title: '错误', content: e.message});
                }).finally(()=>{
                    this.loading = false;
                });
            },
            setPayeeCompany(company){
                this.$emit('on-change', company);
            }
        }
    }
</script>
